import React, { useState } from 'react'
import SearchIcon from '@mui/icons-material/Search'
import {
  Autocomplete,
  Box,
  InputAdornment,
  OutlinedInput,
  TextField
} from '@mui/material'

function RevampedServerSearchbar(props: RevampedServerSearchbarProps) {
  const { onSubmit, onChange, options, defaultValue, handleChange } = props
  const [searchOption, setSearchOption] = useState<string>(defaultValue)
  return (
    <Box
      sx={{ display: 'flex', gap: '20px', alignItems: 'center' }}
      data-cy='search'
    >
      <Autocomplete
        value={searchOption}
        id='search type'
        disableClearable
        onChange={(e, v) => {
          handleChange(e, v)
          setSearchOption(v)
        }}
        options={options}
        sx={{
          minWidth: '125px',
          '& .MuiOutlinedInput-root': {
            padding: '3px 4px 4px 4px'
          }
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            label='Search By'
            variant='standard'
            sx={{
              '& .MuiOutlinedInput-root': {
                padding: '3px 4px 4px 4px'
              }
            }}
          />
        )}
      />
      <OutlinedInput
        placeholder={`Search by ${searchOption.toLowerCase()} ...`}
        onChange={onChange}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            onSubmit()
            e.preventDefault
          }
        }}
        sx={{
          paddingBottom: '0px',
          margin: 'auto',
          background: 'white',
          borderRadius: '8px',
          '.MuiInput-input': {
            marginRight: '8px'
          },
          '& .Mui-focused .MuiOutlinedInput': {
            borderColor: 'gb(223, 225, 229)'
          },
          height: '45px',
          minWidth: '400px',
          boxShadow: '0 1px 6px rgb(32 33 36 / 5%)'
        }}
        endAdornment={
          <InputAdornment
            position='end'
            sx={{ cursor: 'pointer' }}
            onClick={(e) => {
              onSubmit()
              e.preventDefault
            }}
          >
            <SearchIcon
              fontSize='small'
              sx={{
                paddingLeft: '10px'
              }}
            />
          </InputAdornment>
        }
      />
    </Box>
  )
}

export interface RevampedServerSearchbarProps {
  onSubmit
  onChange
  options
  defaultValue
  handleChange
}

export default RevampedServerSearchbar
